//blog handle load more
$(document).on("click", ".js-blog-load-more", function (e) {
  e.preventDefault();
  let url = $(this).data("target");
  $(this).hide();
  if (!url) {
    return;
  }

  $.ajax({
    type: "GET",
    url: url,
    dataType: "html",
    success: function (html) {
      var $blogGrid = $(".blog-grid");
      //remove class to show hidden blog
      $(".blog-grid")
        .find(".blog-item-container-last")
        .removeClass("blog-item-container-last");
      var $html = $(html);
      var $blogItems = $html.find(".blog-item-container");

      $blogGrid.append($blogItems);

      //find load more
      var $originalLoadMore = $("#blog-load-more-container");
      var $loadMore = $html.find("#blog-load-more-container");
      if ($loadMore.length > 0) {
        //remove and replace old load more with the new one
        $originalLoadMore.remove();
        $blogGrid.append($loadMore);
      } else {
        $originalLoadMore.remove();
      }
    },
  });
});